module.exports = __webpack_public_path__ + "images/zorgzaam_small3527250060ef1ee43409bc2f97be0688.png";